import React, { Component } from 'react'
import { Helmet } from 'react-helmet'

import Trip from './../components/Trip'

class Single extends Component {
  componentDidMount() {
    const { bodyClasses, history, match, trip } = this.props

    // Check if optional url parameter is valid
    if (typeof match.params.step !== 'undefined') {
      if (
        !/^\d+$/.test(match.params.step) ||
        (/^\d+$/.test(match.params.step) && parseInt(match.params.step, 10) > trip.acf.steps.length)
      ) {
        history.push({
          pathname: `/${trip.slug}`,
          state: {
            to: 'trip',
          },
        })
      }
    }

    document.body.classList.remove('menu--opened', 'page', 'error-404')
    bodyClasses.forEach(bodyClass => document.body.classList.add(bodyClass))
  }
  render() {
    const { history, match, options, siteTitle, trip, trips, wpforms } = this.props
    const step = typeof match.params.step === 'undefined' ? 1 : parseInt(match.params.step, 10)

    return (
      <div>
        <Helmet>
          <title>{siteTitle}</title>
          <meta property="og:locale" content="fr_FR" />
          <meta property="og:title" content={siteTitle} />
          <meta property="og:site_name" content="Domaine Elisabeth" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:description" content={trip.acf.catch_phrase} />
          {trip.acf.img_trip && <meta property="og:image" content={trip.acf.img_trip.sizes.medium} />}
        </Helmet>
        <Trip
          history={history}
          options={options}
          step={step}
          trip={trip}
          trips={trips}
          wpforms={wpforms}
        />
      </div>
    )
  }
}

export default Single



// WEBPACK FOOTER //
// ./src/pages/Single.js